import { loadStopsToDashboardAPI } from '@/service';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { DashboardLoadRequest, StopMapDTO } from '@/model';
import { useTranslation } from 'react-i18next';
import { ExtractedStopType, GenericPostResponse } from '@/type';
import { extractStops } from '@/page';
import { queryClient } from '@configuration/queryClient.config';

const loadStopsToDashboardBaseQueryKey = ['loadStopsToDashboard'];

const loadStopsToDashboardQueryKey = (filters?: DashboardLoadRequest) => [
  ...loadStopsToDashboardBaseQueryKey,
  filters,
];

export const loadExtractedStopsToDashBoardQueryFetchFunction = (
  filters?: DashboardLoadRequest,
) => loadStopsToDashboardAPI(filters);

export const useLoadExtractedStopsToDashboardQuery = (filters?: DashboardLoadRequest) => {
  const { t } = useTranslation();
  return useQuery<GenericPostResponse<StopMapDTO[]>, Error, ExtractedStopType[]>({
    queryKey: loadStopsToDashboardQueryKey(filters),
    queryFn: () => loadExtractedStopsToDashBoardQueryFetchFunction(filters),
    placeholderData: keepPreviousData,
    select: (result) => extractStops(result.data, t),
  });
};

export const invalidateLoadExtractedStopsToDashboardQuery = () =>
  queryClient.invalidateQueries({
    queryKey: loadStopsToDashboardBaseQueryKey,
  });
